import React, { useEffect } from "react";

import { useParams } from "react-router-dom";
import { getData } from "../libs/firebase/firestore/getData";
import ScreenMyGarden from "./MyGarden/Root";

const ScreenShare = ({}) => {
  // const [loading, setLoading] = React.useState(true);
  const [site, setSite] = React.useState([]);

  const { shareLinkId } = useParams();

  useEffect(() => {
    // get the resource lists from firebase
    getData(`/shareLinks/${shareLinkId}`, (data) => {
      const siteUuid = data.siteUuid;
      getData(`/sites/${siteUuid}`, (data) => {
        setSite(data);
      });
      // setLoading(false);
    });
  }, []);

  const handleUpdated = () => {
    getData(`/sites/${shareLinkId}`, (data) => {
      setSite(data);
      // setLoading(false);
    });
  };

  return <ScreenMyGarden data={site} onUpdated={handleUpdated} />;
};

export default ScreenShare;
